import { useLocation, useNavigate } from "react-router-dom";
import { AppBar, Box, IconButton, Toolbar, Typography } from "@mui/material";
import colorConfigs from "../Sidebar/colourConfigs";
import sizeConfigs from "../Sidebar/sizeConfigs";
import Sidebar from "../Sidebar/Sidebar";
import { useEffect, useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";

const MainLayout = ({ children }) => {
  // const outlet = useOutlet();
  const navigate = useNavigate();

  const [mobileOpen, setMobileOpen] = useState(false);

  const { hash } = useLocation();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // useEffect(() => {
  //   if (outlet === null) {
  //     navigate("/developers");
  //   }
  //   //eslint-disable-next-line
  // }, [outlet]);

  useEffect(() => {
    if (hash !== "") {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView();
      }
    }
  }, [hash]);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignSelf: "flex-start",
        }}
      >
        <Box
          component="nav"
          sx={{
            display: "flex",
            width: { xs: "0px", md: sizeConfigs.sidebar.width },
            flexShrink: 0,
          }}
        >
          <Sidebar
            mobileOpen={mobileOpen}
            setMobileOpen={setMobileOpen}
            handleDrawerToggle={handleDrawerToggle}
          />
        </Box>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            width: {
              xs: "100%",
              md: `calc(100% - ${sizeConfigs.sidebar.width})`,
            },

            minHeight: "100vh",
            backgroundColor: colorConfigs.mainBg,
          }}
        >
          <Toolbar
            sx={{
              alignItems: { xs: "flex-start ", sm: "center" },
            }}
          >
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleDrawerToggle}
              sx={{
                mx: 1,
                display: { md: "none" },
                paddingTop: "28px",
              }}
            >
              <MenuIcon />
            </IconButton>

            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              {children}
            </Typography>
          </Toolbar>
        </Box>
      </Box>
    </>
  );
};

export default MainLayout;
